import React from 'react';

/**
 * Spinner loader
 *
 * @class      Spinner (name)
 * @return     {DOM}  The spinner html
 */
function Spinner(props) {
  const {
    cover = false
  } = props;

  return (
    <div
      className={`col-lg-12 d-flex justify-content-center spinner-wrapper ${cover && 'covered'}`}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
}

export default Spinner;